<template>
    <div class="grid grid-cols-1 place-content-between h-52 p-4" :class="coloreAttivo">
            <div class="flex flex-shrink font-bold">{{ nomeProgetto }}</div>
        <div class="flex justify-between">
            <div class="basis-1/2 flex">
                <div class="flex">
                    <div class="flex-col">
                        <div class="flex-grow px-2 text-white mb-2" :class="coloreStatoClass">{{ siglaStato }}</div>
                        <div class="flex-grow justify-self-center border-2 border-next-neu px-2">{{ siglaTag }}</div>
                    </div>
                    <div class="flex flex-col justify-center">
                        <div class="flex-grow px-2 flex items-center mb-2">{{ statoProgetto }}</div>
                        <div class="flex-grow px-2 flex items-center">{{ tag }}</div>
                    </div>
                </div>
            </div>
            <NextButton variant="outline-secondary" class="basis-1/4 self-end px-3 py-1 ml-3">Vedi</NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ProgettoAttivoCard',
    components:{
        NextButton
    },
    props: {
        nomeProgetto: String,
        siglaStato: String,
        coloreStatoClass: String,
        coloreAttivo: String,
        statoProgetto: String,
        siglaTag: String,
        tag: String,
    }
})
export default class ProgettoAttivoCard extends Vue {
    nomeProgetto!: string
    siglaStato!: string
    coloreStatoClass!: string
    coloreAttivo!: string
    statoProgetto!: string
    siglaTag!: string
    tag!: string
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
